import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, DownloadIcon } from 'lucide-react';
const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Case Studies',
    path: '/#case-studies'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  // Track scroll position for navbar styling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const isActive = (path: string) => {
    if (path === '/#case-studies' && location.hash === '#case-studies') return true;
    return location.pathname === path;
  };
  const handleNavClick = (path: string) => {
    if (path.includes('#')) {
      const id = path.replace('/#', '');
      const element = document.getElementById(id);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth'
        });
      }
    }
    setIsMenuOpen(false);
  };
  return <nav className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/80 backdrop-blur-sm'}`} data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="flex justify-between h-16 md:h-20" data-id="element-113">
          <div className="flex-shrink-0 flex items-center" data-id="element-114">
            <Link to="/" className="text-xl font-bold text-secondary-900 hover:text-primary-600 transition-colors" data-id="element-115">
              Mohit Pole
            </Link>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-6" data-id="element-116">
            {navItems.map(item => <Link key={item.name} to={item.path} className={`px-4 py-2 text-sm font-medium transition-all duration-200 ${isActive(item.path) ? 'text-primary-700 border-b-2 border-primary-500' : 'text-secondary-700 hover:text-primary-600 hover:border-b-2 hover:border-primary-300'}`} onClick={() => handleNavClick(item.path)} data-id="element-117">
                {item.name}
              </Link>)}
            <a href="/resume.pdf" className="ml-4 px-5 py-2 rounded-lg bg-primary-600 text-white text-sm font-medium hover:bg-primary-700 transition-colors flex items-center shadow-sm" target="_blank" rel="noopener noreferrer" data-id="element-118">
              <DownloadIcon className="h-4 w-4 mr-1.5" data-id="element-119" /> Resume
            </a>
          </div>
          {/* Mobile Menu Button */}
          <div className="flex items-center md:hidden" data-id="element-120">
            <button onClick={toggleMenu} className="inline-flex items-center justify-center p-2 rounded-md text-secondary-700 hover:text-primary-600 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-500" aria-expanded={isMenuOpen} data-id="element-121">
              <span className="sr-only" data-id="element-122">
                {isMenuOpen ? 'Close menu' : 'Open menu'}
              </span>
              {isMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-123" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-124" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      <div className={`md:hidden transform transition-all duration-300 ease-in-out ${isMenuOpen ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-125">
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg rounded-b-2xl" data-id="element-126">
          {navItems.map(item => <Link key={item.name} to={item.path} className={`block px-4 py-2.5 rounded-xl text-base font-medium ${isActive(item.path) ? 'text-primary-600 bg-primary-50' : 'text-secondary-700 hover:text-primary-600 hover:bg-primary-50'}`} onClick={() => handleNavClick(item.path)} data-id="element-127">
              {item.name}
            </Link>)}
          <a href="/resume.pdf" className="block px-4 py-2.5 text-base font-medium bg-primary-600 text-white hover:bg-primary-700 mt-3 text-center" target="_blank" rel="noopener noreferrer" data-id="element-128">
            <DownloadIcon className="h-4 w-4 inline mr-1.5" data-id="element-129" /> Resume
          </a>
        </div>
      </div>
    </nav>;
};
export default Navbar;